(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'TwAg6t';

  var CHECK_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  var BELL_ICON  = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';

  window.snapNotifyClick = function (btn) {
    if (!btn || btn.dataset.submitted === 'true') return;
    var wrapper = btn.closest('[data-notify-section]');
    if (!wrapper) return;
    submitNotify(wrapper, btn);
  };

  function submitNotify(wrapper, btn) {
    var email     = btn.dataset.email;
    var variantId = wrapper.dataset.variantId;

    if (!email || !variantId) {
      console.error('[snap-notify] missing email (' + email + ') or variantId (' + variantId + ')');
      showError(btn);
      return;
    }

    btn.classList.add('loading');
    btn.disabled = true;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      }
    )
    .then(function (res) {
      btn.classList.remove('loading');
      return res.text().then(function (body) {
        /* 202 = subscribed, 409 = already subscribed — both are success */
        if (res.status === 202 || res.status === 409) {
          btn.innerHTML = CHECK_ICON + '<span>You\'ll be notified soon!</span>';
          btn.classList.add('notify-me-success');
          btn.dataset.submitted = 'true';
          btn.disabled = true;
        } else {
          console.error('[snap-notify] Klaviyo error ' + res.status + ' (variantId: ' + variantId + ', email: ' + email + '):', body);
          showError(btn);
        }
      });
    })
    .catch(function (err) {
      btn.classList.remove('loading');
      console.error('[snap-notify] fetch error:', err);
      showError(btn);
    });
  }

  function showError(btn) {
    btn.disabled = false;
    btn.classList.add('notify-me-error');
    setTimeout(function () { btn.classList.remove('notify-me-error'); }, 2500);
  }

  function initVariantListener() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (data) {
      if (!data || !data.data) return;
      var variant = data.data.variant;
      if (!variant) return;
      var sectionId = data.data.sectionId || '';
      var wrapper   = document.querySelector('[data-notify-section="' + sectionId + '"]');
      if (wrapper) { updateWrapper(wrapper, variant); }
      else { document.querySelectorAll('[data-notify-section]').forEach(function (w) { updateWrapper(w, variant); }); }
    });
  }

  function updateWrapper(wrapper, variant) {
    wrapper.dataset.variantTitle = variant.title || '';
    wrapper.dataset.variantId    = variant.id    || '';
    wrapper.dataset.soldOut      = variant.available ? 'false' : 'true';
    if (!variant.available) {
      var sid = wrapper.dataset.notifySection;
      var nb  = document.getElementById('notify-me-btn-' + sid);
      if (nb && nb.dataset.submitted !== 'true') {
        nb.disabled = false; nb.style.opacity = '';
        nb.classList.remove('notify-me-success', 'notify-me-error');
        nb.innerHTML = BELL_ICON + '<span>Notify Me When Available</span>';
        delete nb.dataset.submitted;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantListener);
  } else {
    initVariantListener();
  }
})();
